import { ToastContainerContext } from "@kamae-apps/shared/old/Component/Toast/Context"
import { ToastContainer } from "@kamae-apps/shared/old/Component/Toast/Toast"
import { TFunction } from "i18next"
import { FC, ReactNode, useEffect, useRef } from "react"
import { useLocation, useMatch } from "react-router-dom"
import { useFeatureFlags } from "../../hooks/posthog/useFeatureFlags"
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary"
import { ERROR_FALLBACK_LAYOUT } from "../ErrorBoundary/ErrorFallback/ErrorFallback"
import { MessagePortal } from "../MessagePortal/MessagePortal"
import { Menu } from "../Organisms/Menu/Menu"
import { PageLayout, PageLayoutVariant } from "./PageLayout"

type AppLayoutProps = {
  t: TFunction
  isUserLoaded: boolean
  children: ReactNode
  displayNewBeltModal: boolean
  setDisplayNewBeltModal: React.Dispatch<React.SetStateAction<boolean>>
}

export const AppLayout: FC<AppLayoutProps> = ({
  t,
  isUserLoaded,
  children,
  displayNewBeltModal,
  setDisplayNewBeltModal,
}) => {
  const toastRef = useRef<ToastContainer>(null)
  const { pathname } = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: Scroll to top on route change whatever the route is
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  const isPhishingCampaignDetail = useMatch("/phishing/:id") !== null
  const featureFlags = useFeatureFlags()
  const isNewsBarActive = featureFlags.includes("display-news-bar")
  const isAdministrationSubmenu = useMatch("/administration/*") !== null

  return (
    <>
      <div className="min-h-screen max-w-480 m-auto flex flex-col">
        <MessagePortal
          isNewsBarActive={isNewsBarActive}
          displayNewBeltModal={displayNewBeltModal}
          setDisplayNewBeltModal={setDisplayNewBeltModal}
        />
        <Menu
          t={t}
          isNewsBarActive={isNewsBarActive}
        />
        <ToastContainerContext.Provider value={toastRef}>
          <div className="grow overflow-y-auto overflow-x-hidden scroll-smooth custom-scrollbar relative flex flex-col">
            <PageLayout
              variant={
                isAdministrationSubmenu
                  ? PageLayoutVariant.NONE
                  : isPhishingCampaignDetail
                    ? PageLayoutVariant.WHITE
                    : PageLayoutVariant.GLASS
              }
            >
              {isUserLoaded && (
                <ErrorBoundary
                  layout={ERROR_FALLBACK_LAYOUT.PAGE}
                  resetKey={pathname}
                >
                  {children}
                </ErrorBoundary>
              )}
              <ToastContainer ref={toastRef} />
            </PageLayout>
          </div>
        </ToastContainerContext.Provider>
      </div>
    </>
  )
}
